import { render, staticRenderFns } from "./NsDynamicFieldset.vue?vue&type=template&id=cb545ba6&scoped=true&"
import script from "./NsDynamicFieldset.vue?vue&type=script&lang=js&"
export * from "./NsDynamicFieldset.vue?vue&type=script&lang=js&"
import style0 from "./NsDynamicFieldset.vue?vue&type=style&index=0&id=cb545ba6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb545ba6",
  null
  
)

export default component.exports